// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2021 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
export default {
  data() {
    return {
      disabled: false,
      text: "获取验证码"
    };
  },
  mounted() {
    this.text = this.translateVerifyText("获取验证码");
  },
  methods: {
    translateVerifyText(text, seconds) {
      if (typeof this.$tt !== "function") return seconds !== undefined ? `${text} ${seconds}s` : text;
      if (text === "剩余") return `${this.$tt("剩余")} ${seconds}s`;
      return this.$tt(text);
    },
    sendCode() {
      if (this.disabled) return;
      this.disabled = true;
      let n = 60;
      this.text = this.translateVerifyText("剩余", n);
      const run = setInterval(() => {
        n = n - 1;
        if (n < 0) {
          clearInterval(run);
        }
        this.text = this.translateVerifyText("剩余", n);
        if (n < 0) {
          this.disabled = false;
          this.text = this.translateVerifyText("重新获取");
        }
      }, 1000);
    }
  }
};
